module.exports = __webpack_public_path__ + "img/jesse-myrberg-min.7c4b498b.jpg";